import { useGetCurrentUserWorkbookAccess } from "@/business/query";
import { useGetMyUser } from "./query";
import { isAdminOrOwner } from "./utils";

export const useUserManagementAccess = (businessId?: string | null) => {
  const { data: user, isLoading: userLoading } = useGetMyUser();
  const enabled = Boolean(businessId) && isAdminOrOwner(user?.role);
  const query = useGetCurrentUserWorkbookAccess(businessId, { enabled });
  return {
    canManageWorkbookAccess:
      enabled && query.data?.can_manage_access === true && !query.isError,
    canManageUsers:
      enabled && query.data?.can_manage_users === true && !query.isError,
    isLoading:
      userLoading || (enabled && !query.isFetchedAfterMount && !query.isError),
    isError: enabled && query.isError,
    retry: query.refetch,
  };
};
